<template>
    <div class="buyerListWrap11">
        <div class="searchBox">
            <div class="left">
                <el-form :inline="true">
                    <el-form-item label="买家总人数">
                        共{{customerTotal}} 位
                    </el-form-item>
                    <el-form-item style="width: 250px;">
                        <el-input  style="width: 250px;" placeholder="手机号/姓名/公司名称" v-model="fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right">
                <el-form :inline="true">
                  <el-form-item>
                      <el-select placeholder="选择公司" v-model="currentSelectCompany" @change="multiSearchClick" >
                          <el-option label="所有公司" value=""></el-option>
                          <el-option :label="list.text" :value="list.value" v-for="(list,index) in companyWord" :key="index"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item>
                      <el-select placeholder="身份类型" v-model="userType" @change="multiSearchClick">
                          <el-option label="全部身份" value=""></el-option>
                          <el-option :label="list.text" :value="list.value" v-for="(list,index) in userTypeOptions" :key="index"></el-option>
                      </el-select>
                  </el-form-item>
                    <el-form-item>
                       <el-button type="primary" @click="downLoadExcel(3)">下载列表</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" >
                <el-table-column type="selection" width="35">
                </el-table-column>
                <el-table-column label="序号" width="40">
                    <template slot-scope="scope">{{total-((page-1)*num+ scope.$index )}}</template>
                </el-table-column>
                <el-table-column label="姓名">
                    <template slot-scope="scope">{{ scope.row.userName }}</template>
                </el-table-column>
                <el-table-column label="手机号">
                    <template slot-scope="scope">{{ scope.row.phone }}</template>
                </el-table-column>
                <el-table-column label="公司">
                    <template slot-scope="scope">{{ scope.row.companyName }}</template>
                </el-table-column>
                <el-table-column label="报名时间">
                    <template slot-scope="scope">{{ scope.row.registerTime }}</template>
                </el-table-column>
                <el-table-column label="上级姓名">
                    <template slot-scope="scope">{{ scope.row.superiorName }}</template>
                </el-table-column>
                <el-table-column label="邀请人数 ">
                    <template slot-scope="scope">{{ scope.row.inviteNum }} 人</template>
                </el-table-column>
                <el-table-column label="操作"  width="420">
                    <template slot-scope="scope">
                        <div style="text-align: center;color:#aaa;">
                            <span class="spanBtn" @click="toDetail(scope.row)">详情</span>
                            <div  v-if="function_changeCustomerPower" style="display: inline-block;">
                                <span class="" >
                                    <el-switch   v-model="scope.row.isOverrideCode" @change="changeReletionshipPower(scope.row)"></el-switch>
                                    <span :class="{blue:scope.row.isOverrideCode}">改变上下级关系</span>
                                     
                                </span>
                                <span class="" >
                                    <el-switch   v-model="scope.row.isShowSubData" @change="changeViewPower(scope.row)"></el-switch>
                                    <span  :class="{blue:scope.row.isShowSubData}">查看受邀人购买情况</span>
                                      
                                </span>
                            </div>
                            
                            

                            
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page"
                :page-size.sync="num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {        json,       wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,api    } from '@/common/request.js'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                conferenceId:'',
                isLoading:false,
                tableData:[],
                customerTotal:'',
                //查询条件
                fuzzyQuery:'',
                page: 1,
                num: 10,
                userType:'',
                currentSelectCompany:'',
                searchObj:{},//最终组装好的搜索条件
                
               
                total:0,
                companyWord:[],
            }
        },
        components: {
        },
        computed: {
            function_changeCustomerPower(){
                return utils.getCurrentFunction().indexOf("changeCustomerPower")>-1
            },
            IMG_PREV() {
                return api.imgPrev
            },
            userTypeOptions() {
                return wordData.user_type
            },
            adminId(){
                return utils.getAdminId()
            }
            
            
        },
        methods: {
            changeCompany(){
            },
            getCompanyOption(){
                let _this=this
                let arg={
                    conferenceId:_this.conferenceId,
                }
                ajaxPost('/admin/companylist', arg).then(function(res) {
                    if(res.errorCode==200){
                        let resData=res.data?res.data:[]
                        _this.companyWord=resData.map(function(item,index){
                            let buffer={
                                text:item.companyName,
                                value:item.userId,
                            }
                            return buffer
                        })
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
            },
            downLoadExcel(type){
                let _this=this
                let arg={
                    adminId:_this.adminId,
                    conferenceId:_this.conferenceId,
                    type:type
                }
                ajaxPost('/file/exportHttp', arg).then(function(res) {
                    console.log(res)
                    if(res.errorCode==200){
                        _this.$message("下载成功")  
            
                        let url=res.data
                        window.location.href= _this.IMG_PREV+url
                        
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
            },
            refreshPage(){
                this.getTableLists()
            },
            changeReletionshipPower(list){
                let _this=this
                if(!confirm("确定改变该用户权限吗？")){
                    list.isOverrideCode=!list.isOverrideCode
                    return false
                }
                console.log(list)
                alert("功能暂未开启")

                this.refreshPage()
            },
            changeViewPower(list){
                let _this=this
                if(!confirm("确定改变该用户权限吗？")){
                    list.isShowSubData=!list.isShowSubData
                    return false
                }
                alert("功能暂未开启")
                _this.refreshPage()


            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
            },
            fuzzySearchClick() {
                let _this=this
                _this.userType=""
                _this.page=1
                _this.currentSelectCompany= ""
                _this.getTableLists()
            },
            multiSearchClick() {
                this.fuzzyQuery=""
                this.page=1
                this.getTableLists()
               
            },
            handleSizeChange(size) { //分页：每页n条
                this.num = size
                this.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.page = page
                this.getTableLists()
            },
            getTableLists(){
                let _this=this
                _this.isLoading=true
                _this.searchObj={
                    num:_this.num,
                    page:_this.page,
                    fuzzyQuery:_this.fuzzyQuery,
                    userType: this.userType,
                    userId: this.currentSelectCompany,
                }
                let arg=JSON.parse(JSON.stringify( _this.searchObj))
                arg.conferenceId=_this.conferenceId
                ajaxPost('/admin/getbuyerList',arg).then(function(res) {
                    
                    if(res.data.buyerList){
                         _this.tableData=res.data.buyerList.map(function(item,index){
                             if(item.userAuthInfo){
                                 let obj=JSON.parse(item.userAuthInfo)
                                 item.isOverrideCode=obj.isOverrideCode=='y'?true:false
                                 item.isShowSubData=obj.isShowSubData=='y'?true:false
                             }
                             return item
                         })
                    }
                    _this.total=parseInt(res.data.total) 
                    _this.customerTotal=res.data.total
                    setTimeout(function(){
                        _this.isLoading=false
                    },100)

                }, function(res) {
                    _this.isLoading=false

                })
            },
            toDetail(list) {
                let _this=this
                let userId=list.userId
                this.$router.push({name: 'activeInnerBuyerDetail',params: { userId: userId ,conferenceId:_this.conferenceId}})
            },
        },
        mounted(){
            this.getParams()
            this.getCompanyOption()
           this.getTableLists()
           

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
    // *{outline: 1px solid blue;}
    .buyerListWrap11 {
      background: #fff;
       .searchBox {
           padding: 0.25rem 0.25rem 0;
       
           .left {
               float: left;
           }
       
           .right {
             float:right;
           }
       }
       
       .searchBox:after {
           content: "";
           display: block;
           clear: both;
       }
       
       .tableBox {
           padding: 0.25rem; padding-top:0;
       }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/buyer.vue